<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/subscription-account']"><span translate>SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT</span></a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_MANAGEMENT</span>
</div>
<tb-header *ngIf="!this.ifNfs" specificTitle="SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_MANAGEMENT"></tb-header>
<tb-header *ngIf="this.ifNfs" specificTitle="SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_NFS_MANAGEMENT"></tb-header>

<div class="management" style="position: relative; height: 100%">
    <div style="width: 35%; height: 100%; overflow-y: auto">
        <div style="width: 100%; display: flex; justify-content: space-between" class="table-head">
            <div><span class="mat-card-title" translate>COMMONS.SUBSCRIPTION</span></div>
            <div
                *ngIf="
                    (!this.storeRoleService.IsInternal && this.customerService.canSeeNFSSection && !this.storeRoleService.isBetaTester) ||
                    this.storeRoleService.isWebSiteAdmin
                "
            >
                <button
                    #selectButton
                    class="select-button button-icon-text"
                    mat-flat-button
                    *ngIf="!this.storeRoleService?.IsInternal && this.ifNfs"
                    color="primary"
                    matTooltip="{{ 'M_SUB_MNG_TOOLTIP_4' | translate }}"
                    matTooltipClass="tooltip-layout"
                    routerLinkActive="router-link-active"
                    style="padding: 0 20px"
                    (click)="select?.open()"
                    (focus)="addOverlay()"
                >
                    <mat-icon>add</mat-icon>
                    <span translate>ACC_FEAT1</span>

                    <mat-select (selectionChange)="onChange($event.value)">
                        <mat-option
                            *ngIf="this.customerService?.ListOfMandati?.get('MAWEB')?.length > 0"
                            [disabled]="this.disableButtonNFSMW"
                            [ngClass]="{ disabledButtonLink: this.disableButtonNFSMW }"
                            (click)="navigateMagoWeb()"
                            >Not For Sale MagoWeb</mat-option
                        >
                        <mat-option
                            *ngIf="this.customerService?.ListOfMandati?.get('MCLOUD')?.length > 0"
                            [disabled]="this.disableButtonNFS"
                            [ngClass]="{ disabledButtonLink: this.disableButtonNFS }"
                            (click)="navigateMagoCloud()"
                            >Not For Sale MagoCloud</mat-option
                        >
                    </mat-select>
                </button>
            </div>
        </div>
        <div class="sections border bt-0">
            <!-- SUBSCRIPTION-TABLE -->
            <ms-subscription-table
                [ifNfs]="ifNfs"
                [disableButtonNFS]="disableButtonNFS"
                [isExcellencePartnerMC]="isExcellencePartnerMC"
                [isPremiumPartnerMC]="isPremiumPartnerMC"
                [nfsMessageExcellence]="nfsMessageExcellence"
                [nfsMessagePremium]="nfsMessagePremium"
                [searchSubscription]="searchSubscription"
                [subscriptionFound]="subscriptionFound"
                [dataSourceSubscription]="dataSourceSubscription"
                (setSubscription)="setSubscription($event)"
                (applyFilter)="applyFilter($event)"
            >
            </ms-subscription-table>
            <!-- SUBSCRIPTION-TABLE -->
        </div>
    </div>
    <div style="width: 65%; height: 100%">
        <div>
            <ms-subscription-information
                *ngIf="showSubscriptionTab && !subscriptionIsDisabled && subscriptionFound"
                [currentsubscriptionKey]="selectedSubscription"
                [isMoving]="hasMoved"
                [isSubNfs]="ifNfs"
                (subKey)="subKeyClicked($event)"
                (descriptionChanged)="descriptionChange($event)"
            >
            </ms-subscription-information>
            <div
                class="message-box info"
                *ngIf="!showSubscriptionTab && selectedSubscription !== undefined"
                style="margin: 5rem; margin-top: 2rem"
                translate
            >
                SUBSCRIPTIONS_ACCOUNTS.NOT_EDITABLE_4_YOU
            </div>

            <div
                class="message-box info"
                *ngIf="subscriptionIsDisabled && selectedSubscription !== undefined"
                style="margin: 5rem; margin-top: 2rem"
                translate
            >
                {{ subscriptionDisabledMessage }}
            </div>

            <div class="message-box info" *ngIf="!subscriptionFound" style="margin: 5rem; margin-top: 2rem" translate>
                M_SUB_MNG_SUB_NOT_FOUND
            </div>
        </div>
        <div *ngIf="loading">
            <tb-loading></tb-loading>
        </div>
    </div>
</div>
